import React from "react";

const About = () => (
	<section id="about" className="py-16 px-6 max-w-4xl mx-auto">
		<h3 className="text-3xl font-bold text-red-500 mb-4">Who We Are</h3>
		<p className="text-gray-700">
			Fornido Development Company Limited is a technology and infrastructure
			company dedicated to providing top-notch IT, construction, and facility
			development services that drive innovation and sustainability.
		</p>
	</section>
);

export default About;
